var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['l-reset-reality-button',
           'c-reset-reality-button',
           {'c-reset-reality-button-celestial': _vm.isInCelestialReality}],on:{"click":_vm.resetReality}},[_c('div',{staticClass:"l-reality-button__contents"},[_vm._v(" "+_vm._s(_vm.resetText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }